import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { PushWrapper } from './Push.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import useIsGlobetrotter from '../../hooks/useIsGlobetrotter.js';
import Icon from '../Icon/Icon.js';
import { ICON_UI_ARROW_RIGHT } from '../../icons/ICON_UI_ARROW_RIGHT.js';
import { ICON_UI_CHEVRON_RIGHT } from '../../icons/ICON_UI_CHEVRON_RIGHT.js';

var _excluded = ["children", "href"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Push = function Push(_ref) {
  var children = _ref.children,
    href = _ref.href,
    rest = _objectWithoutProperties(_ref, _excluded);
  var isGlobe = useIsGlobetrotter();
  if (!children || !href) {
    return null;
  }
  var arrowIcon = isGlobe ? ICON_UI_ARROW_RIGHT : ICON_UI_CHEVRON_RIGHT;
  return /*#__PURE__*/jsxs(PushWrapper, _objectSpread(_objectSpread({
    href: href
  }, rest), {}, {
    children: [children, /*#__PURE__*/jsx(Icon, {
      path: arrowIcon,
      size: isGlobe ? 's' : 'xs'
    })]
  }));
};
var Push$1 = Push;

export { Push$1 as default };
//# sourceMappingURL=Push.js.map
